import { Hero } from '../components/Hero/Hero';

export const HomePage = () => {
  return <Hero />;
};
